import { CpmTooltip } from '../../../components/design-system';

interface InfoIProps {
    title: string;
    body: string;
    align?: 'start' | 'center';
}

export default function InfoI({ title, body, align = 'center' }: InfoIProps) {
    return (
        <CpmTooltip title={title} content={body} align={align} side="top" fit>
            <span
                className="inline-flex items-center justify-center shrink-0"
                style={{
                    width: 15,
                    height: 15,
                    borderRadius: 'var(--cpm-radius-full)',
                    border: '1.5px solid var(--cpm-border-strong)',
                    background: '#fff',
                    color: 'var(--cpm-text-tertiary)',
                    fontSize: 10,
                    fontWeight: 800,
                    cursor: 'help',
                    lineHeight: 1,
                }}
            >
                i
            </span>
        </CpmTooltip>
    );
}
